import { Button } from '@cms/components/data/Button'
import { BROWSER_EVENTS } from '@cms/utils/constants'
import clsx from 'clsx'
import React from 'react'
import { RiErrorWarningFill } from 'react-icons/ri'

interface CustomEmbedPluginContainerProps {
    embedTitle?: React.ReactNode
    embedDescription?: React.ReactNode
    embedActionComponent?: React.ReactNode
    instructionsTitle?: React.ReactNode
    instructionsScreenshotUrl?: string
    instructionsNotesComponent?: React.ReactNode
}

/**
 * Component used to wrap custom embed components, it consists of two parts
 * the action part on the right and the instructions part on the right
 */
export const CustomEmbedPluginContainer: React.FC<CustomEmbedPluginContainerProps> = (props) => {
    const {
        // actionTitle = 'Adding custom feature',
        embedTitle = 'Embed element',
        embedDescription = '',
        embedActionComponent,
        instructionsTitle = 'How will look the component once included',
        instructionsScreenshotUrl,
        instructionsNotesComponent,
    } = props

    if (!embedActionComponent) {
        return null
    }

    return (
        <div className="grid grid-cols-2 gap-x-20 gap-y-4 p-10">
            <div className="flex flex-col gap-4">
                <p className="text-lg text-cs-dark-gray my-2" >
                    {embedDescription}
                </p>

                {embedActionComponent}
            </div>

            <div className="flex flex-col gap-4">
                {instructionsScreenshotUrl && (
                    <>
                        <img className="h-[40vh] w-auto max-w-full" src={instructionsScreenshotUrl} alt={`${embedTitle} screenshot`} />
                        <p className="text-sm text-cs-normal-gray">{instructionsTitle}</p>
                    </>
                )}

            </div>
            <div
                className='col-span-full'
            >
                {instructionsNotesComponent}
            </div>
        </div>
    )
}


interface CustomEmbedPluginActionsProps {
    handleCancel?: () => void;
    handleSubmit: () => void;
}

export const CustomEmbedPluginActions: React.FC<CustomEmbedPluginActionsProps> = (props) => {
    const handleSubmit = () => {
        if (props.handleSubmit) {
            props.handleSubmit();
        }

        handleCancel();
    }

    const handleCancel = () => {
        if (props.handleCancel) {
            props.handleCancel();
        }

        window.dispatchEvent(new Event(BROWSER_EVENTS.CLOSE_MODAL));
    }

    return (
        <div className='flex items-center justify-end py-2 gap-2'>
            <Button
                type='button'
                onClick={handleCancel}
                inputVariant='none'
            >
                Cancel
            </Button>
            <Button
                type='button'
                inputVariant='white_text_dark_bg'
                onClick={handleSubmit}
            >
                Submit
            </Button>
        </div>
    )
}

interface CustomEmbedPluginNoteProps {
    wrapperClassName?: string;
    notes: Array<{
        title: React.ReactNode;
        description: React.ReactNode;
    }>;
}

export const CustomEmbedPluginNote: React.FC<CustomEmbedPluginNoteProps> = (props) => {
    const { wrapperClassName = '', notes = [] } = props;

    return (
        <div
            className={clsx(
                'p-4 border border-cs-300 rounded-2xl shadow-lg',
                'bg-linear-to-b from-[#FFFFFF] to-[#F1F1F1]',
                'flex items-center gap-2',
                wrapperClassName
            )}
        >
            {notes.map((note, index) => (
                <div
                    key={index}
                    className={clsx(
                        'flex',
                        notes.length > 1 ? "flex-col items-start gap-2" : "items-center gap-8",
                    )}
                >
                    <div className='flex items-center gap-2'>
                        <RiErrorWarningFill
                            className='w-6 h-6 fill-cs-500'
                        />
                        {note.title && <p className='text-lg'>{note.title}</p>}
                    </div>

                    <div>
                        {note.description}
                    </div>
                </div>
            ))}
        </div>
    )
}